import { useEffect, useState } from "react";

/**
 * Responsive breakpoint hook.
 * Returns true when the viewport width is less than or equal to the provided maxWidth.
 */
export function useBreakpoint(maxWidth = 1024) {
  const [isNarrow, setIsNarrow] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= maxWidth;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const update = () => setIsNarrow(mq.matches);

    update();
    mq.addEventListener("change", update);

    return () => mq.removeEventListener("change", update);
  }, [maxWidth]);

  return isNarrow;
}
